import ArtifactGroupType from "@/roc/museum/base/ArtifactGroupType";

const CaptainsHat = {
  id: '93',
  name: 'Captains Hat',
  icon: 'CaptainsHat',
  groupIcon: 'LegendsOfTheHighSeas',
  type: ArtifactGroupType.LEGENDS_OF_THE_HIGH_SEAS,
  power: 10,
  gameId: 'CaptainsHat'
};

export default CaptainsHat;
